import { render, staticRenderFns } from "./GillTitle.vue?vue&type=template&id=24554f1b&scoped=true"
import script from "./GillTitle.vue?vue&type=script&lang=js"
export * from "./GillTitle.vue?vue&type=script&lang=js"
import style0 from "./GillTitle.vue?vue&type=style&index=0&id=24554f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24554f1b",
  null
  
)

export default component.exports